import styled from 'styled-components';

export const StyledAddFormBloc = styled.div`
  .bloc {
    min-height: 106px;
    width: 98%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #f4f4f4;
    border-radius: 5px;
    padding: 16px;
  }
  .title {
    padding: 10px 0;
    color: #707070;
  }
  .add-content-bloc-button {
    padding: 10px;
    height: 36px;
  }
`;
